module.exports = __webpack_public_path__ + "static/qh_9.77cee668.jpg";